import { PrimeIcons } from "primereact/api";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { setProjectePreferred } from "services";
import { updatePreferredProjectStatus } from "store/slicer/GestioneProjectsSlice";
import { useAppDispatch } from "store/store";

export const ButtonSetProjectPreferred = ({
  projectId,
  isPreferred,
  customClass,
}: {
  projectId: string;
  isPreferred: boolean;
  customClass?: string;
}) => {
  const dispatch = useAppDispatch();
  const [savingPreferred, setSavingPreferred] = useState(false);
  const [newIsPreferred, setNewIsPreferred] = useState<boolean>();

  useEffect(() => {
    setNewIsPreferred(isPreferred);
  }, [isPreferred]);

  const toggleFavorite = (e: any) => {
    e.stopPropagation();
    if (projectId && !savingPreferred) {
      setSavingPreferred(true);
      setProjectePreferred({
        projectId: projectId,
        preferred: !newIsPreferred,
      })
        .then((_) => {
          dispatch(
            updatePreferredProjectStatus({
              id: projectId,
              preferred: !newIsPreferred,
            } as any)
          );
          setNewIsPreferred(!newIsPreferred);
        })
        .catch((_) => {})
        .finally(() => setSavingPreferred(false));
    }
  };

  return (
    <Button
      icon={newIsPreferred ? PrimeIcons.STAR_FILL : PrimeIcons.STAR}
      className={`favorite-project ${customClass} ${
        newIsPreferred ? "favourite-icon-filled" : "favourite-icon"
      }`}
      disabled={savingPreferred}
      text
      onClick={(e) => toggleFavorite(e)}
    />
  );
};
